import { useQuery } from '@tanstack/react-query';
import { client } from './api-client';

// Get expert chat tickets by vehicle ID
export const useGetExpertChatTickets = (vehicleId) => {
  return useQuery(
    ['expert-chat-tickets', vehicleId],
    async () => {
      if (!vehicleId) {
        return { tickets: [], total: 0 };
      }
      
      const searchParams = new URLSearchParams({
        vehicle_id: vehicleId,
      });
      
      const response = await client(`zendesk/tickets?${searchParams.toString()}`);
      
      if (response?.error) {
        throw new Error(response.error);
      }
      
      return response || { tickets: [], total: 0 };
    },
    {
      enabled: !!vehicleId,
      keepPreviousData: true,
    }
  );
};

export const fetchExpertChatHistory = async (conversationId) => {
  if (!conversationId) return [];

  const response = await client(`zendesk/messages/conversation/${conversationId}`);
  if (!response) return [];

  if (Array.isArray(response.messages)) {
    return response.messages;
  }

  if (Array.isArray(response)) {
    return response;
  }

  return [];
};

export const sendExpertChatMessage = async ({ email, message, vehicleId, conversationId }) => {
  if (!email || !message) {
    throw new Error('Missing email or message payload for expert chat send');
  }

  return client('zendesk/send', {
    data: {
      user_id: email,
      message,
      vehicle_id: vehicleId ?? null,
      conversation_id: conversationId ?? null,
    },
  });
};

export const closeTicket = async (ticketId) => {
  if (!ticketId) {
    throw new Error('Missing ticket ID for closing ticket');
  }

  return client(`zendesk/tickets/${ticketId}/close`, {
    method: 'POST',
  });
};